import './header.component.scss'
// import './header.component.pug'
import { SwitchState } from '../../helpers/app/modules/switch-state'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
// import { Application } from '../../helpers/app'
const togglerButton = document.querySelector('.header-opener')
const navigation = document.querySelector('.header-nav')

function openMenu() {
  navigation.classList.add('opened')
  togglerButton.innerHTML = `<span class="fal fa-times"></span>`
  disableBodyScroll(navigation)
}
function closeMenu() {
  navigation.classList.remove('opened')
  togglerButton.innerHTML = `<span class="fal fa-bars"></span>`
  enableBodyScroll(navigation)
}
export const menuSwitcher = new SwitchState(
  {
    element: togglerButton,
    state: false
  },
  openMenu,
  closeMenu
)
menuSwitcher.call()
